import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
{
    id: "po-07-h5v2-01",
    name: "PO 01 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
    size: [1217, 851],
    style: {},
        slots: [          
            { id: "1", x: 45, y: 156, width: 245, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 339, width: 245, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 45, y: 521, width: 245, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 156, width: 269, height: 539, rotation: 0, imageRotation: 0 },
            { id: "5", x: 911, y: 239, width: 234, height: 374, rotation: 0, imageRotation: 0 },
            { id: "6", x: 669, y: 239, width: 234, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 669, y: 430, width: 234, height: 183, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h5v2-02",
    name: "PO 02 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 69, y: 171, width: 471, height: 330, rotation: 0, imageRotation: 0 },
        { id: "2", x: 69, y: 509, width: 108, height: 172, rotation: 0, imageRotation: 0 },
        { id: "3", x: 185, y: 509, width: 241, height: 172, rotation: 0, imageRotation: 0 },
        { id: "4", x: 434, y: 509, width: 107, height: 172, rotation: 0, imageRotation: 0 },
        { id: "5", x: 677, y: 171, width: 471, height: 337, rotation: 0, imageRotation: 0 },
        { id: "6", x: 677, y: 516, width: 232, height: 164, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 516, width: 231, height: 164, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-03",
    name: "PO 03 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 41, y: 171, width: 232, height: 165, rotation: 0, imageRotation: 0 },
        { id: "2", x: 41, y: 344, width: 232, height: 165, rotation: 0, imageRotation: 0 },
        { id: "3", x: 41, y: 517, width: 232, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 281, y: 171, width: 294, height: 510, rotation: 0, imageRotation: 0 },
        { id: "5", x: 669, y: 171, width: 484, height: 260, rotation: 0, imageRotation: 0 },
        { id: "6", x: 669, y: 439, width: 319, height: 240, rotation: 0, imageRotation: 0 },
        { id: "7", x: 996, y: 439, width: 156, height: 240, rotation: 0, imageRotation: 0 }  
    ],
},

{
    id: "po-07-h5v2-04",
    name: "PO 04 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 232, width: 517, height: 386, rotation: 0, imageRotation: 0 },
        { id: "2", x: 525, y: 232, width: 133, height: 189, rotation: 0, imageRotation: 0 },     
        { id: "3", x: 666, y: 232, width: 272, height: 189, rotation: 0, imageRotation: 0 },
        { id: "4", x: 946, y: 232, width: 271, height: 189, rotation: 0, imageRotation: 0 },
        { id: "5", x: 525, y: 429, width: 272, height: 189, rotation: 0, imageRotation: 0 },
        { id: "6", x: 805, y: 429, width: 272, height: 189, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1085, y: 429, width: 132, height: 189, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-07-h5v2-05",
    name: "PO 05 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 46, y: 234, width: 317, height: 227, rotation: 0, imageRotation: 0 },
        { id: "2", x: 371, y: 234, width: 317, height: 227, rotation: 0, imageRotation: 0 },
        { id: "3", x: 46, y: 469, width: 209, height: 148, rotation: 0, imageRotation: 0 },
        { id: "4", x: 263, y: 469, width: 209, height: 148, rotation: 0, imageRotation: 0 },
        { id: "5", x: 480, y: 469, width: 208, height: 148, rotation: 0, imageRotation: 0 },
        { id: "6", x: 696, y: 234, width: 234, height: 383, rotation: 0, imageRotation: 0 },
        { id: "7", x: 938, y: 234, width: 233, height: 383, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-06",
    name: "PO 06 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 49, y: 125, width: 556, height: 397, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 125, width: 274, height: 397, rotation: 0, imageRotation: 0 },
        { id: "3", x: 895, y: 125, width: 273, height: 397, rotation: 0, imageRotation: 0 },
        { id: "4", x: 49, y: 530, width: 274, height: 194, rotation: 0, imageRotation: 0 },
        { id: "5", x: 331, y: 530, width: 274, height: 194, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 530, width: 274, height: 194, rotation: 0, imageRotation: 0 },
        { id: "7", x: 895, y: 530, width: 273, height: 194, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-07",
    name: "PO 07 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 176, width: 213, height: 162, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 346, width: 213, height: 161, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 515, width: 213, height: 161, rotation: 0, imageRotation: 0 },
        { id: "4", x: 221, y: 176, width: 341, height: 500, rotation: 0, imageRotation: 0 },
        { id: "5", x: 570, y: 176, width: 341, height: 500, rotation: 0, imageRotation: 0 },
        { id: "6", x: 919, y: 176, width: 298, height: 246, rotation: 0, imageRotation: 0 },
        { id: "7", x: 919, y: 430, width: 298, height: 246, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-08",
    name: "PO 08 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 176, width: 213, height: 162, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 346, width: 213, height: 161, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 515, width: 213, height: 161, rotation: 0, imageRotation: 0 },
        { id: "4", x: 221, y: 176, width: 342, height: 500, rotation: 0, imageRotation: 0 },
        { id: "5", x: 876, y: 176, width: 341, height: 500, rotation: 0, imageRotation: 0 },     
        { id: "6", x: 571, y: 176, width: 297, height: 246, rotation: 0, imageRotation: 0 },
        { id: "7", x: 571, y: 430, width: 297, height: 246, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-09",
    name: "PO 09 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 49, y: 153, width: 177, height: 131, rotation: 0, imageRotation: 0 },
        { id: "2", x: 49, y: 292, width: 177, height: 130, rotation: 0, imageRotation: 0 },
        { id: "3", x: 49, y: 430, width: 177, height: 130, rotation: 0, imageRotation: 0 },
        { id: "4", x: 49, y: 568, width: 177, height: 130, rotation: 0, imageRotation: 0 },
        { id: "5", x: 234, y: 153, width: 750, height: 545, rotation: 0, imageRotation: 0 },
        { id: "6", x: 992, y: 153, width: 175, height: 269, rotation: 0, imageRotation: 0 },
        { id: "7", x: 992, y: 430, width: 175, height: 268, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-10",
    name: "PO 10 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 49, y: 153, width: 751, height: 545, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 808, y: 153, width: 176, height: 131, rotation: 0, imageRotation: 0 },
        { id: "3", x: 808, y: 292, width: 176, height: 130, rotation: 0, imageRotation: 0 },
        { id: "4", x: 808, y: 430, width: 176, height: 130, rotation: 0, imageRotation: 0 },
        { id: "5", x: 808, y: 568, width: 176, height: 130, rotation: 0, imageRotation: 0 },
        { id: "6", x: 992, y: 153, width: 176, height: 269, rotation: 0, imageRotation: 0 },
        { id: "7", x: 992, y: 430, width: 176, height: 268, rotation: 0, imageRotation: 0 }
    ],
}
];